import { useContext } from 'react';
import Box from '@mui/material/Box';
import Fab from '@mui/material/Fab';
import Zoom from '@mui/material/Zoom';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import useMediaQuery from '@mui/material/useMediaQuery';
import useScrollTrigger from '@mui/material/useScrollTrigger';
import { useTheme } from '@mui/material/styles';
import { GlobalContext } from '../context/GlobalState';
import { strings } from 'localisation';

const SHOW_AFTER_PX = 400;

export default function BackToTopButton() {
  const theme = useTheme();
  const { lang } = useContext(GlobalContext);
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const scrolled = useScrollTrigger({ disableHysteresis: true, threshold: SHOW_AFTER_PX });

  if (!isMobile) return null;

  const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  return (
    // The full-width strip centers the button without a translateX, which Zoom's inline
    // scale() transform would otherwise overwrite. It ignores taps so it never eats a
    // click meant for the product content it floats over.
    <Box
      sx={{
        position: 'fixed',
        bottom: 'calc(16px + env(safe-area-inset-bottom))',
        left: 0,
        right: 0,
        display: 'flex',
        justifyContent: 'center',
        pointerEvents: 'none',
        zIndex: (t) => t.zIndex.fab
      }}>
      <Zoom in={scrolled} unmountOnExit>
        <Fab
          size="medium"
          color="primary"
          onClick={scrollToTop}
          aria-label={strings[lang]?.scrollToTop || strings.default.scrollToTop}
          sx={{
            pointerEvents: 'auto',
            '&:hover': {
              backgroundColor: 'secondary.main',
              color: 'secondary.contrastText'
            }
          }}>
          <KeyboardArrowUpIcon />
        </Fab>
      </Zoom>
    </Box>
  );
}
